window.addEventListener('alpine:init', () => {
  function carousel(data = {}) {
    return {
      ...data,

      progress: 0,

      scrollLeft: 0,

      scrollProgress: 0,

      refs: {
        slider: this.$el.querySelector('[x-ref="slider"]'),
        slides: this.$el.querySelector('[x-ref="slides"]') || this.$el.querySelector('[x-ref="slider"]'),
        slideAll: this.$el.querySelectorAll('[x-ref="slide"]')
      },

      init() {
        this.onSliderScroll = this.onSliderScroll.bind(this);

        this.$nextTick(() => this.setProgress());

        this.refs.slider.addEventListener('scroll', this.onSliderScroll);

        var observer = new MutationObserver(() => {
          requestAnimationFrame(() => this.setProgress());
        });

        observer.observe(this.$el, { subtree: true, childList: true });
      },

      destroy() {
        this.refs.slider.removeEventListener('scroll', this.onSliderScroll);
      },

      onSliderScroll() {
        this.setProgress();
      },

      setProgress() {
        this.scrollLeft = this.refs.slider.scrollLeft;

        var scrollerLeft = this.scrollLeft / this.refs.slider.scrollWidth * this.refs.slider.offsetWidth;

        var scrollerWidth = (this.refs.slider.offsetWidth / this.refs.slider.scrollWidth) * this.refs.slider.offsetWidth;

        this.progress = ((scrollerLeft + scrollerWidth) / this.refs.slider.offsetWidth * 100);

        var scrollProgress = Math.round(100 * this.scrollLeft / (this.refs.slider.scrollWidth - this.refs.slider.clientWidth));

        this.scrollProgress = isNaN(scrollProgress) ? 100 : scrollProgress;
      },

      scrollTo(index, behavior = 'auto') {
        this.to((current, offset) => offset * (index - 1), behavior);
      },

      scrollToNext(behavior = 'auto') {
        this.to((current, offset) => current + offset, behavior);
      },

      scrollToPrev(behavior = 'auto') {
        this.to((current, offset) => current - offset, behavior);
      },

      to(strategy, behavior = 'auto') {
        var current = this.scrollLeft;
        var offset = this.refs.slides.firstElementChild.getBoundingClientRect().width;

        this.refs.slider.scrollTo({ left: strategy(current, offset), behavior: behavior });
      },

      getSlideIsActiveState(slideIndex) {
        var slidesLength = this.refs.slideAll.length;

        return (
          this.scrollProgress >= (slideIndex * (100 / slidesLength)) &&
          this.scrollProgress <= ((slideIndex + 1) * (100 / slidesLength))
        );
      },

      checkElInView(el) {
        var cLeft = this.scrollLeft;
        var cRight = cLeft + this.refs.slider.clientWidth;

        var eLeft = el.offsetLeft;
        var eRight = eLeft + (el.clientWidth / 2);

        var isTotal = (eLeft >= cLeft && eRight <= cRight);

        return isTotal;
      }
    };
  };

  Alpine.data('carousel', carousel);
});
